/**
 * Customer Agent
 * @author David <david.prenninger@gmx.de>
 *
 * This file provides the application store to all customer related data.
 * Its filled by information injected into the URL by the backend.
 * This information is only injected on the customerService email link.
 */
export default {
  state: {
    customerAgentData: {},
  },
  mutations: {
    SET_C_A_DATA(currentState, payload) {
      currentState.customerAgentData = payload;
    },
  },
  actions: {
    setCustomerAgentData(context, payload) {
      context.commit('SET_C_A_DATA', payload);
    },
  },
  getters: {
    customerAgentData(state) {
      return state.customerAgentData;
    },
  },
};
